import { baseUrl } from "./config.js"
export const http = function (options) {
	{
		return new Promise((resolve, reject) => {
			let token = uni.getStorageSync('token')
			// 在登录的时候需要储存 token uni.setStorageSync("authorization","这里是登录获取的token值")

			// uni.showLoading({
			// 	title:"加载中..."
			// })
			uni.showLoading({
				title: '加载中',
				mask: true
			})
			uni.request({
				url: baseUrl + options.url,
				data: options.data || {},
				method: options.method || 'GET',
				header: options.header || {
					// 根据实际接口设计 key 取 token 或者 authorization
					token: token,
					"content-type": 'application/json'
				},
				success: (res) => {
					let data = res.data
					// 控制台显示数据信息
					uni.hideLoading()
					// 登录过期
					if (data.code === 401) {
						uni.navigateTo({
							url: '/packageA/loginAgain/loginAgain'
						})
					}
					if (data.code !== 200) {
						uni.showToast({
							title: data.message,
							icon: "none",
							duration: 2000
						})
					}
					resolve(data)
					// return response.data
				},
				fail: (err) => {
					// 页面中弹框显示失败
					uni.showToast({
						title: '请求接口失败'
					})
					// 返回错误消息
					reject(err)
					uni.hideLoading()
					return Promise.reject(err)
				},
				catch: (e) => {
					console.log(e)
				}
			})
		})
	}
}